var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"order-center-school-roll-container"},[_c('simple-table',{attrs:{"isCheckbox":!1,"data":_vm.tableData,"pagination":_vm.pagination,"columns":_vm.columns,"loading":_vm.loading},on:{"update:pagination":function($event){_vm.pagination=$event},"query":_vm.initData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }